var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"officialUrl"},[_c('el-form-item',{attrs:{"label":"官方网址：","prop":"officialUrl"}},[_c('el-input',{staticClass:"fl",staticStyle:{"width":"50%"},attrs:{"type":"text"},model:{value:(_vm.ruleForm.officialUrl),callback:function ($$v) {_vm.$set(_vm.ruleForm, "officialUrl", $$v)},expression:"ruleForm.officialUrl"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }